import { Link, useNavigate } from "react-router-dom";
import { Logo, NAV_LINKS } from "./Header";
import { scrollToId } from "@/lib/scroll";
import { SERVICE_LINKS } from "@/data/prestations";

export const Footer = () => {
  const navigate = useNavigate();
  const go = (href) => {
    if (document.querySelector(href)) {
      scrollToId(href);
    } else {
      navigate("/");
      setTimeout(() => scrollToId(href), 600);
    }
  };

  return (
  <footer data-testid="site-footer" className="bg-nuit text-casse">
    <div className="mx-auto max-w-7xl px-6 lg:px-10 py-16 lg:py-20 grid gap-12 sm:grid-cols-2 lg:grid-cols-4">
      <div>
        <Logo light testId="footer-logo" />
        <p className="mt-6 font-heading text-base font-semibold text-casse" data-testid="footer-brand">
          LIMEN<br />Aménagement &amp; Rénovation
        </p>
        <p className="mt-3 text-sm text-casse/60" data-testid="footer-tagline">
          Isolation • Plaquisterie • Aménagement intérieur
        </p>
      </div>

      <div>
        <h3 className="font-accent text-[11px] font-medium tracking-[0.3em] uppercase text-casse/50">Contact</h3>
        <ul className="mt-5 space-y-3 text-sm text-casse/80" data-testid="footer-contact">
          <li>
            <a href="tel:+33786256965" data-testid="footer-phone" className="hover:text-sable transition-colors duration-300">
              07 86 25 69 65
            </a>
          </li>
          <li>
            <a href="mailto:contact@limen-ar.fr" data-testid="footer-email" className="hover:text-sable transition-colors duration-300">
              contact@limen-ar.fr
            </a>
          </li>
          <li data-testid="footer-website">limen-ar.fr</li>
          <li data-testid="footer-zone">Basée en Seine-et-Marne — projets étudiés partout</li>
        </ul>
      </div>

      <div>
        <h3 className="font-accent text-[11px] font-medium tracking-[0.3em] uppercase text-casse/50">Prestations</h3>
        <ul className="mt-5 space-y-3 text-sm" data-testid="footer-prestations">
          {SERVICE_LINKS.map((s) => (
            <li key={s.slug}>
              <Link
                to={`/${s.slug}`}
                data-testid={`footer-prestation-${s.slug}`}
                className="text-casse/80 hover:text-sable transition-colors duration-300"
              >
                {s.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h3 className="font-accent text-[11px] font-medium tracking-[0.3em] uppercase text-casse/50">Navigation</h3>
        <ul className="mt-5 space-y-3 text-sm" data-testid="footer-nav">
          {NAV_LINKS.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                data-testid={`footer-nav-${l.href.slice(1)}`}
                onClick={(e) => { e.preventDefault(); go(l.href); }}
                className="text-casse/80 hover:text-sable transition-colors duration-300"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>

    <div className="border-t border-casse/10">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-casse/50" data-testid="footer-copyright">
          © LIMEN Aménagement &amp; Rénovation — Tous droits réservés
        </p>
        <div className="flex items-center gap-6">
          <Link to="/mentions-legales" data-testid="footer-legal-link" className="text-xs text-casse/50 hover:text-sable transition-colors duration-300">
            Mentions légales
          </Link>
          <Link to="/politique-de-confidentialite" data-testid="footer-privacy-link" className="text-xs text-casse/50 hover:text-sable transition-colors duration-300">
            Politique de confidentialité
          </Link>
        </div>
      </div>
    </div>
  </footer>
  );
};
